<section class="page">
  <header class="page-header">
    <h2>Clients</h2>
    <p class="subtitle">Créez, modifiez et supprimez les clients.</p>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }



  <div class="forms-grid">
    @if (showCreateSection) {
      <form class="panel" (ngSubmit)="createClient()">
        <h3>Créer un client</h3>


        <label for="new-identifiant">Identifiant *</label>
        <input id="new-identifiant" name="newIdentifiant" [(ngModel)]="identifiant" maxlength="255" required />

        <label for="new-url">Site web</label>
        <input id="new-url" name="newUrl" [(ngModel)]="urlSiteWeb" maxlength="255" />

        <label class="checkbox-row" for="new-interne">
          <input id="new-interne" name="newInterne" type="checkbox" [(ngModel)]="interne" (ngModelChange)="onInterneChange()" />
          <span>Client interne</span>
        </label>

        @if (interne) {
          
          <label for="new-bu">Business Unit</label>
          <input id="new-bu" name="newBusinessUnit" [(ngModel)]="businessUnit" maxlength="255" />
          <label for="new-contrat">Site ou contrat</label>
          <input id="new-contrat" name="newSiteOuContrat" [(ngModel)]="siteOuContrat" maxlength="255" />
        }

        <button type="submit" [disabled]="loading">Créer</button>
      </form>
    }

    @if (showEditSection) {
      <form class="panel" (ngSubmit)="updateClient()">
        <h3>Modifier un client</h3>
        <label for="select-client">Client</label>
        <select id="select-client" name="selectedId" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
          <option value="">-- sélectionner --</option>
          @for (client of clients; track client.id) {
            <option [value]="client.id">{{ client.identifiant }}</option>
          }
        </select>


        <label for="edit-identifiant">Identifiant *</label>
        <input id="edit-identifiant" name="editIdentifiant" [(ngModel)]="identifiant" maxlength="255" required />

        <label for="edit-url">Site web</label>
        <input id="edit-url" name="editUrl" [(ngModel)]="urlSiteWeb" maxlength="255" />

        <label class="checkbox-row" for="edit-interne">
          <input id="edit-interne" name="editInterne" type="checkbox" [(ngModel)]="interne" (ngModelChange)="onInterneChange()" />
          <span>Client interne</span>
        </label>

        @if (interne) {
          <label for="edit-bu">Business Unit</label>
          <input id="edit-bu" name="editBusinessUnit" [(ngModel)]="businessUnit" maxlength="255" />
          <label for="edit-contrat">Site ou contrat</label>
          <input id="edit-" name="editSiteOuContrat" [(ngModel)]="siteOuContrat" maxlength="255" />
        }

        @if (pageMode === 'gerer') {
          <div class="actions">
            <button type="submit" [disabled]="loading">Enregistrer</button>
            <button type="button" class="danger" (click)="deleteClient()" [disabled]="loading || !selectedId">Supprimer</button>
          </div>
        } @else {
          <button type="submit" [disabled]="loading">Enregistrer</button>
        }
      </form>
    }
  </div>

  @if (showListSection) {
    <section class="panel">
      <div class="list-header">
        <h3>Liste des clients</h3>
      </div>
      @if (loadingList) {
        <p>Chargement des clients...</p>
      } @else if (clients.length === 0) {
        <p>Aucun client disponible.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Identifiant</th>
                <th>Site web</th>
                <th>Interne</th>
                <th>Business Unit</th>
                <th>Site ou contrat</th>
                @if (showRowActionsInTable) {
                  <th>Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (client of clients; track client.id) {
                <tr>
                  <td>{{ client.id }}</td>
                  <td>{{ client.identifiant }}</td>
                  <td>{{ client.url_site_web }}</td>
                  <td>{{ client.interne ? 'Oui' : 'Non' }}</td>
                  <td>{{ client.businessUnit }}</td>
                  <td>{{ client.siteOuContrat }}</td>
                  @if (showRowActionsInTable) {
                    <td class="actions-cell">
                      <button
                        type="button"
                        class="secondary"
                        [disabled]="loading"
                        (click)="editClient(client)"
                      >
                        Éditer
                      </button>
                      @if (showDeleteActionsInTable) {
                      <button
                        type="button"
                        class="danger"
                        [disabled]="loading || deletingClientId === client.id"
                        (click)="deleteClientRow(client)"
                      >
                        {{ deletingClientId === client.id ? 'Suppression...' : 'Supprimer' }}
                      </button>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }
</section>
